import { createConfirmation } from "react-confirm";
import OrderDetailDialog from "./OrderDetailDialog";

export const showOrderDetailDialog = createConfirmation(OrderDetailDialog);
